export function buildTimelineQueryParams(state, includePagination = true) {
    const params = {mode: state.mode};

    if (state.mode === 'year' && state.selectedYear) {
        params.year = state.selectedYear;
    }

    params.entry_filter = state.positionFilterSelection;
    params.only_scheduled = state.positionFilterSelection === 'with_dates' ? 1 : 0;

    if (state.searchFilter && String(state.searchFilter).trim() !== '') {
        params.search = String(state.searchFilter).trim();
    }

    if (state.canFilterCompanies && state.companyFilterSelection !== 'all') {
        const companyId = Number(state.companyFilterSelection);
        if (!Number.isNaN(companyId)) {
            params.company_id = companyId;
        }
    }

    params.sort_column = state.sortColumn;
    params.sort_order = state.sortOrder;

    if (includePagination) {
        params.per_page = state.perPageSelection;
        params.page = state.currentPage;
    }

    return params;
}

export function mapTimelineResponse(data, state) {
    const availableYears = Array.isArray(data.years) ? data.years : [];
    const companyOptions = Array.isArray(data.companies)
        ? data.companies
        : [];
    const canFilterCompanies = !!data.can_filter_companies;

    let companyFilterSelection = state.companyFilterSelection;
    if (!canFilterCompanies) {
        companyFilterSelection = 'all';
    } else if (data.selected_company_id) {
        companyFilterSelection = String(data.selected_company_id);
    } else if (
        companyFilterSelection !== 'all'
        && !companyOptions.some((item) => String(item.id) === companyFilterSelection)
    ) {
        companyFilterSelection = 'all';
    }

    let selectedYear = null;
    if (state.mode === 'year') {
        const serverYear = data.year ? Number(data.year) : null;
        if (serverYear) {
            selectedYear = serverYear;
        } else if (availableYears.length > 0) {
            selectedYear = Number(availableYears[availableYears.length - 1]);
        }
    }

    return {
        availableYears: availableYears,
        searchFilter: typeof data.search === 'string' ? data.search : state.searchFilter,
        rangeStart: data.range_start || null,
        rangeEnd: data.range_end || null,
        today: data.today || null,
        rows: Array.isArray(data.rows)
            ? data.rows
            : (Array.isArray(data.positions) ? data.positions : []),
        totalPositions: Number(
            data.total_rows
            || data.total_positions
            || (Array.isArray(data.rows) ? data.rows.length : 0)
            || (Array.isArray(data.positions) ? data.positions.length : 0)
            || 0
        ),
        canFilterCompanies: canFilterCompanies,
        companyOptions: companyOptions,
        sortColumn: data.sort_column ? String(data.sort_column) : state.sortColumn,
        sortOrder: data.sort_order ? String(data.sort_order) : state.sortOrder,
        perPageSelection: data.per_page ? Number(data.per_page) : state.perPageSelection,
        currentPage: Math.max(1, Number(data.page || state.currentPage || 1)),
        totalPages: Math.max(1, Number(data.total_pages || 1)),
        pageFrom: Math.max(0, Number(data.from || 0)),
        pageTo: Math.max(0, Number(data.to || 0)),
        positionFilterSelection: typeof data.entry_filter === 'string' && data.entry_filter !== ''
            ? data.entry_filter
            : (
                typeof data.only_scheduled === 'undefined'
                    ? state.positionFilterSelection
                    : (data.only_scheduled ? 'with_dates' : 'all')
            ),
        companyFilterSelection: companyFilterSelection,
        selectedYear: selectedYear,
    };
}

export function captureDateAnchor(momentLib, rangeStart, pixelsPerDay, shell) {
    if (!shell || !rangeStart) {
        return null;
    }

    return {
        date: momentLib(rangeStart, 'YYYY-MM-DD')
            .add((shell.scrollLeft + (shell.clientWidth / 2)) / Math.max(1, pixelsPerDay), 'days'),
        viewportOffset: shell.clientWidth / 2,
    };
}

export function calculateDateAnchorScrollLeft(momentLib, rangeStart, pixelsPerDay, anchor, shell) {
    if (!shell || !anchor || !rangeStart) {
        return null;
    }

    const anchorOffsetDays = anchor.date.diff(momentLib(rangeStart, 'YYYY-MM-DD'), 'days', true);
    const targetLeft = (anchorOffsetDays * pixelsPerDay) - anchor.viewportOffset;
    const maxLeft = Math.max(0, shell.scrollWidth - shell.clientWidth);

    return Math.max(0, Math.min(maxLeft, targetLeft));
}
